export const BusinessProfileConstants = {
  GET_PROFILE: 'GET_BUSINESS_PROFILE',
  EDIT_INFO: 'EDIT_INFO_BUSINESS_PROFILE',
  UPDATE_DATA: 'UPDATE_DATA_BUSINESS_PROFILE',

  UPDATE_DATA_REQUEST: 'UPDATE_DATA_VACANCIES',

  IS_LOADING: 'IS_LOADING_BUSINESS',
  IS_LOADING_MODAL: 'IS_LOADING_MODAL',
  IS_LOADING_REPORT: 'IS_LOADING_REPORT',

  UPDATE_SUCCESS: 'UPDATE_SUCCESS_BUSINESS',
  REDIRECT: 'REDIRECT_BUSNESS',
  UPDATE_DATA_FLAGS: 'UPDATE_DATA_FLAGS',

  UPDATE_USERS: 'UPDATE_USERS',
  UPDATE_NEWS: 'UPDATE_NEWS',

  SET_TAB_APPLICANTS: 'SET_TAB_APPLICANTS',
  SET_TAB_VACANCIES: 'SET_TAB_VACANCIES',

  SET_VACANCIES_DAYS: 'SET_VACANCIES_DAYS',
  SET_APPLICANTS_DAYS: 'SET_APPLICANTS_DAYS',

  IS_OK: 'IS_OK',
  UPDATE_ERROR: 'UPDATE_ERROR_BUSINESS_PROFILE',
};
